<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="warning.1"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <path id="Path_7966" data-name="Path 7966" d="M0,0H54V54H0Z" fill="none" />
    <path
      id="Path_7967"
      data-name="Path 7967"
      d="M12.313,17.8V9.38m0,15.176a.563.563,0,1,0,.565.563.559.559,0,0,0-.565-.563"
      transform="translate(14.687 11.725)"
      fill="none"
      :stroke="clr ? clr : `#ec484a`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_7968"
      data-name="Path 7968"
      d="M29.065,5.612,46.3,35.771a5.26,5.26,0,0,1-4.565,7.868H7.267A5.258,5.258,0,0,1,2.7,35.771L19.934,5.612a5.256,5.256,0,0,1,9.13,0Z"
      transform="translate(2.5 3.701)"
      fill="none"
      :stroke="clr ? clr : `#ec484a`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
